import React from 'react';
import useThemeAccent from '../../hooks/use-theme-accent';
function getLogo(provider, themeAccent, cdnUrl) {
    const logo = `${cdnUrl}/${provider.toLowerCase()}/logo-${themeAccent}.svg`;
    return () => React.createElement("img", { src: logo, width: 60, height: 60, alt: `${provider} logo` });
}
export const ProviderLogo = ({ provider, customLogo, cdnUrl }) => {
    const themeAccent = useThemeAccent();
    return customLogo ? customLogo({ themeAccent }) : getLogo(provider, themeAccent, cdnUrl)({});
};
